import React from 'react';

import PlayButtonSvg from 'assets/images/play-button.svg';

import BaseIcon from './BaseIcon';

const PlayButtonIcon = props => (
  <BaseIcon {...props} src={PlayButtonSvg} />
);

export default PlayButtonIcon;
